// ---------------------------------------------------------------------------
// One question, asked from two places: the onboarding dialog asks it on the way
// in, and `AccountMenu` asks it again for anybody who pressed Later.
//
// A counter, not a boolean, and that is what makes it small. "Later" is
// recorded as the nonce it was pressed at rather than as a flag, so asking
// again is one increment: the recorded value stops matching and the dialog
// comes back, with no effect to run and nothing to reset afterwards.
//
// It exists because "Later" used to be permanent for the life of the page. A
// signed-in account with no username is a real state — PlayerChip draws it, and
// says "signed in" rather than `@null` — and until now the only route out of it
// was a reload.
//
// Its own module rather than an export beside the dialog, so neither file has
// more than one kind of thing in it.
// ---------------------------------------------------------------------------

import { create } from 'zustand';

export const useUsernamePrompt = create<{ nonce: number }>(() => ({ nonce: 0 }));

/** Ask for the username again, from anywhere. */
export function requestUsernamePrompt(): void {
  useUsernamePrompt.setState((held) => ({ nonce: held.nonce + 1 }));
}
